import { createSlice } from '@reduxjs/toolkit';

import { myOrders, updateOrders, downloadOrders, getVendors, getRejectedOrders, downloadPackingListMyOrders, recoverRejectedOrders, getdownloadSkuLabel,downloadSkuLabel } from '../../apis';

export const MyOrders = createSlice({
    name: 'myOrders',
    initialState: {
        IsLoading: false,
        data : [],
        error: '',
        updateOrdersSuccess: false,
        downloadOrdersUrl: '',
        downloadPackingListMyOrdersUrl: '',
        getVendorsData: [],
        recoverRejectedOrdersSuccess: false,
        downloadSkuLabelData: [],
        downloadSkuLabelSuccess: false,
    },
    reducers: {
        updateOrdersSuccessState: (state, action) => {
            return {
                ...state,
                updateOrdersSuccess: action.payload
            }
        },
        emptyDownloadShippingUrl: (state, action) => {
            return {
                ...state,
                downloadOrdersUrl: action.payload
            }
        },
        clearErrorState: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        emptyDownloadPackingListMyOrdersUrl: (state, action) => {
            return {
                ...state,
                downloadPackingListMyOrdersUrl: action.payload
            }
        },
        clearRecoverRejectedOrdersSuccess: (state, action) => {
            return {
                ...state,
                recoverRejectedOrdersSuccess: action.payload
            }
        },
    },

    extraReducers: (builder) => {
        builder.addCase(myOrders.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(myOrders.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.error = '';
            state.data = action.payload.data
        })
        builder.addCase(myOrders.rejected, (state, action) => {
            state.error = action.payload.message;
            state.IsLoading = false;
        })
        builder.addCase(updateOrders.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(updateOrders.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.error = '';
            state.data = action.payload.data;
            state.updateOrdersSuccess = true;
        })
        builder.addCase(updateOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        // builder.addCase(downloadOrders.pending, (state, action) => {
        //     console.log('pending')
        //     state.IsLoading = true;
        // })
        // builder.addCase(downloadOrders.fulfilled, (state, action) => {
        //     console.log('fulfilled')
        //     state.IsLoading = true;
        //     state.error = '';
        //     state.downloadOrdersUrl = action.payload.data;
        // })
        // builder.addCase(downloadOrders.rejected, (state, action) => {
        //     console.log('rejected')
        //     state.error = action.payload
        //     state.IsLoading = false;
        // })
        builder.addCase(getVendors.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(getVendors.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.getVendorsData = action.payload.data;
            state.error = '';
        })
        builder.addCase(getVendors.rejected, (state, action) => {
            state.error = action.payload.message;
            state.IsLoading = false;
        })
        builder.addCase(getRejectedOrders.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(getRejectedOrders.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.data = action.payload.data;
            state.error = '';
        })
        builder.addCase(getRejectedOrders.rejected, (state, action) => {
            state.error = action.payload.message;
            state.IsLoading = false;
        })
        builder.addCase(downloadPackingListMyOrders.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(downloadPackingListMyOrders.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.error = '';
            state.downloadPackingListMyOrdersUrl = action.payload.data;
        })
        builder.addCase(downloadPackingListMyOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(recoverRejectedOrders.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(recoverRejectedOrders.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.error = '';
            state.recoverRejectedOrdersSuccess = true;
        })
        builder.addCase(recoverRejectedOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(getdownloadSkuLabel.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(getdownloadSkuLabel.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.downloadSkuLabelData = action.payload.data?.sku_details;
            state.error = '';
        })
        builder.addCase(getdownloadSkuLabel.rejected, (state, action) => {
            state.error = action.payload.message;
            state.IsLoading = false;
        })
        // builder.addCase(downloadSkuLabel.pending, (state, action) => {
        //     state.IsLoading = true;
        // })
        // builder.addCase(downloadSkuLabel.fulfilled, (state, action) => {
        //     state.IsLoading = true;
        //     state.downloadSkuLabelSuccess = true;
        //     state.error = '';
        // })
        // builder.addCase(downloadSkuLabel.rejected, (state, action) => {
        //     state.error = action.payload.message;
        //     state.IsLoading = false;
        // })
    }
})

export const { updateOrdersSuccessState, emptyDownloadShippingUrl, clearErrorState, emptyDownloadPackingListMyOrdersUrl, clearRecoverRejectedOrdersSuccess } = MyOrders.actions
export default MyOrders.reducer